import React from 'react';
import { useInput, useTranslate } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';

import { filterColors } from '../../utils/constants';
import { FilterToggleButtonGroup, StyledToggleButton } from './FilterToggleInput';


const useStyles = makeStyles({
	filterState: {
		backgroundColor: filterColors.state
	},
});


export const ToggleStateEnum = [
	{
		value: "notActive",
		name: "osfc.filters.state.not_active",
	},
	{
		value: "active",
		name: "osfc.filters.state.active",
	},
];


export const ToggleStateFilter = ({ toggleStates = ToggleStateEnum, ...props} ) => {
	const translate = useTranslate();
	const classes = useStyles();
	const { input } = useInput(props);
	const value = input.value;

	const handleChange = (e, newValue) => {
		input.onChange(newValue);
	};

	return (
		<FilterToggleButtonGroup value={value} onChange={handleChange} label={input.label} exclusive className={classes.filterState}>
			{toggleStates.map((state, index) => 
				<StyledToggleButton value={state.value} key={index}>
					{translate(state.name)}
				</StyledToggleButton>
			)}
		</FilterToggleButtonGroup>
	);
};
